import { ref } from 'vue'
import { getAuth, sendPasswordResetEmail } from 'firebase/auth'


const useResetPassword = () => {
    const error = ref(null)
    const isPending = ref(false)
    const success = ref(false)

    const resetPassword = async (email) => {
        error.value = null
        isPending.value = true
        success.value = false

        try {
            const auth = getAuth()
            await sendPasswordResetEmail(auth, email)

            success.value = true
            isPending.value = false
            return { success: true }
        } catch (err) {
            console.error("Failed to reset password:", err)

            // Handle specific Firebase error codes
            switch (err.code) {
                case 'auth/user-not-found':
                    error.value = 'No account found with this email address'
                    break
                case 'auth/invalid-email':
                    error.value = 'Invalid email address format'
                    break
                case 'auth/too-many-requests':
                    error.value = 'Too many requests. Please try again later'
                    break
                default:
                    error.value = 'Failed to send reset email. Please try again'
            }

            isPending.value = false
            success.value = false
            return { success: false, error: error.value }
        }
    }

    return {
        resetPassword,
        error,
        isPending,
        success
    }
}

export default useResetPassword
